
import { Component, Vue, Ref } from 'vue-property-decorator'
import { CommonService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import TableList from '../components/top_table.vue'
@Component({
    components: {
        ScrollTo,
        TableList
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private isLoading = true
    private firstInit = true
    private pathName = ''

    async mounted() {
        this.pathName = this.$route.name || ''
        await this.getList()
        if (this.firstInit) {
            this.isLoading = false
        }
        this.firstInit = false
    }


    async getList() {
        this.isLoading = true
        const params = {
            top: 1
        }
        const result = await CommonService.getIArticleList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            if (this.pathName === 'ContentInstituteTopList') {
                this.list = result.data.list.filter((item: any) => item.type.name.indexOf('酷公司/') === -1)
            } else {
                this.list = result.data.list.filter((item: any) => item.type.name.indexOf('酷公司/') !== -1)
            }
            this.$forceUpdate()
        }
        if (!this.firstInit) {
            this.isLoading = false
        }
    }

    // 分页
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 删除
    private onDelete(article: any) {
        this.$confirm('你正在移出置顶文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteRequest(article)
        })
    }

    // 设为置顶
    async onSelect(article: any) {
        const params = {
            id: article.id,
            top: 2,
            type_id: article.type.id
        }
        const result = await CommonService.updateIArticle(params) 
        if (result.status === 200) {
            await this.getList()
            this.$message({
                type: 'success',
                message: '设置成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    async deleteRequest(article: any) {
        const params = { id: article.id, recommend: 0 }
        if (article.top) {
            Object.assign(params, { top: 0 })
        }
        const result = await CommonService.updateIArticle(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(article), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '移出成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    onChange() {
        this.getList()
    }
}
